/**
 * src/lib/voice/copilotVoiceEvent.js — TICKET-912 slice 3.
 *
 * Voice mode reuses the floating bot's whole voice stack (VAD, streaming STT with the
 * UVTP fallback, streaming TTS, barge-in, language picker). In Quote Copilot mode the
 * turn goes to the deal's copilot (agent.chat scope 'quote_copilot', stream:true)
 * instead of voice.chat. The copilot does not stream text tokens: it streams
 * `progress` while it works and delivers the whole answer in `done` (or a refusal
 * in `error`). This maps those events onto the voice pipeline's refs + sentence
 * buffer, so the existing TTS path speaks the answer.
 *
 * Contract with useVoiceConversation's sseCtx: aiTextRef, aiFullTextRef,
 * setLastAiText, setLastAiFullText, sentenceBuffer {push, flush}, streamDoneRef.
 * An `error` event THROWS, so sendToAgent's existing catch surfaces it (visible
 * error + Retry) exactly like a failed voice.chat.
 */
export function handleCopilotVoiceEvent(event, ctx) {
  if (!event) return;
  const { type, data } = event;
  if (type === 'done') {
    const text = String(data?.content || '').trim();
    ctx.aiTextRef.current = text;
    ctx.aiFullTextRef.current = text;
    ctx.setLastAiText?.(text);
    ctx.setLastAiFullText?.(text);
    if (text) ctx.sentenceBuffer?.push(text);
    ctx.sentenceBuffer?.flush();
    ctx.streamDoneRef.current = true;
    return;
  }
  if (type === 'error') {
    ctx.sentenceBuffer?.flush();
    ctx.streamDoneRef.current = true;
    throw new Error(data?.error || 'The Quote Copilot could not answer. Try again.');
  }
  // `progress` ({type:'thinking'|'tool'}): nothing to speak; the overlay stays in
  // its processing state until `done`.
}
